



import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {GripVertical,Minus,Paperclip,Plus,X} from 'lucide-react';

  
const SectionsQuizAddMoreLoading=()=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
    


    
     useEffect(()=>{
     
     },[])



     const [text, setText] = useState("");
     const [wordCount, setWordCount] = useState(0);
    
     const handleChange = (event) => {
       const inputText = event.target.value;
       const words = inputText.trim().split(/\s+/); // Split by spaces, ignoring extra spaces
       const count = words[0] === "" ? 0 : words.length; // Handle empty input edge case
   
       if (count <= 50) {
         setText(inputText);
         setWordCount(count);
       }
     };
   return(<>
  
   <div 
   
   
   style={{padding:"5px",margin:"5px", marginTop:"10px",borderRadius:"10px",background:"#fff",
   boxShadow: "0 7px 20px 0 rgba(48, 25, 131, 0.053)",border:"3px solid #f1f1f1"}}> 
    { <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"30px",height:"30px",cursor:"pointer",float:"right",borderRadius:"50%",
    margin:"10px", marginTop:"10px",
      background:"#f1f1f1"}}><X  style={{margin:"6px"}} color="#ffffff" size={18}/></div>}
    
 
<div  style={{}}>
    <div style={{}}>
    
    
    </div> 
    <div>
    <div className="YoutubeVideoLinkCardInner"  > 
    
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
    //   style={{width:"50px",height:"40px",marginLeft:"-15px",position:"relative",
    //   borderRadius:"50%",
    //    alignContent:"center",textAlign:"center",padding:"5px",}}
       >
          {/* <GripVertical color="#958FDA" size={32} /> */}
          </div>  
        {<div style={{height:"30px",width:"200px",marginTop:"2px"}}  className="text-linetw"></div>}
        
        
        
        </div>
        {/* <div  className="coloredTextV1" >
        Word count: {wordCount} / 50
      </div> */}
       {<div style={{height:"70px",marginTop:"10px"}}>
        <div style={{background:"#ffffff", display:"flex", justifyContent:"space-around",borderRadius:"15px",marginTop:"10px",paddingTop:"10px",paddingBottom:"10px",}}>  
                    <div  className=" text-linetw" style={{fontSize:"16px",fontWeight:"bold",padding:"8px",paddingTop:"15px"}}></div>         
               <div style={{margin: '5px' ,paddingLeft:"0px",width:"150px", display:"flex", justifyContent:"space-around" ,alignItems:"center"  }}>
 <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{border:"3px solid #f1f1f1 ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="#f1f1f1" size={13}/>
    <div onMouseEnter={handleMouseEnter} disabled
     onMouseLeave={handleMouseLeave}    style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",
            padding:"0px",marginLeft:"19px",fontSize:"20px",color:"#555555 ",background:"#fff",fontWeight:"bolder",marginTop:"0px",}}
      ></div>  <Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  style={{border:"3px solid #f1f1f1 ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",marginLeft:"-15px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}}  color="#f1f1f1" size={13}/>
        
        
        
        </div>  <div className=" text-linetw" style={{fontSize:"18px",fontWeight:"bold",padding:"8px",paddingTop:"15px"}}></div> </div>
        </div>}
        <div  className=""style={{display:"flex",justifyContent:"right"}}>
        <div  onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} 
               
               onClick={ ()=>{   }}
               className=" text-linetw" style={{height:"40px",width:"120px",color:"#555555",display:"flex",justifyContent:"space-between"}} > <div style={{marginTop:"4px"}}></div>  
               </div></div>
   <div style={{float:"right",padding:"15px"}}>
   
   
    </div> 
    
     
    </div>
    
    </div>
    
    </div></>)
}  

export default SectionsQuizAddMoreLoading;
